<style>

.edit, .edit-container{
  display: grid;
  grid-template-columns: auto 32px;
  /* grid-template-rows: 50px; */
  align-items: center;
  border: 1px rgba(255,255,255,0.2) solid;
  background-color: rgba(255,255,255,0.07);
  border-radius: 10px;
  margin: 10px 3px;
}
.edit-container{
  grid-template-rows: 50px auto auto;
}
.edit-info{
  grid-column: 1;
  grid-row: 1;
}
.edit-icon{
  grid-column: 2;
  grid-row: 1;
}
.edit-item{
  margin: 0 10px 10px 10px;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}
.edit-see-more{
  text-align: center;
  margin-bottom: 10px;
  grid-row: 3;
  grid-column-start: 1;
  grid-column-end: 3;
}
.title{
  margin: 10px;
}

</style>

<div class="{title != '' ? 'edit-container' : 'edit'}" on:click="{ () => dispatch('click') }">
  {#if title}
  <div class="edit-info">
    <div class="title">
      {title}
      {#if required}
      <span class="required"> *</span>
      {/if}
    </div>
  </div>
  <div class="edit-icon">
    {#if icon}
      <i class="icon-{icon}"></i>
    {/if}
  </div>
  {/if}
  <div class="edit-item">
    <slot></slot>
  </div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let title = "";
export let icon = "";
export let required = false;

</script>